import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/reportes`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  ingresosTotalesPorMes(mesInicial, mesFinal, porPuntos) {
    let params = {
      mes_inicial: mesInicial,
      mes_final: mesFinal,
      por_puntos: porPuntos || false
    }

    return apiClient.get('ingresos/totales-por-mes', {
      params: params
    })
  },

  contratosCanceladosPorMes(mesInicial, mesFinal, porPuntos) {
    let params = {
      mes_inicial: mesInicial,
      mes_final: mesFinal,
      por_puntos: porPuntos || false
    }

    return apiClient.get('contratos/cancelados-por-mes', {
      params: params
    })
  },

  nuevosPorMes(mesInicial, mesFinal) {
    let params = {
      mes_inicial: mesInicial,
      mes_final: mesFinal
    }

    return apiClient.get('clientes/nuevos-por-mes', {
      params: params
    })
  }
}
